/** Full-color portal mark (green emblem + wordmark), transparent background */
export const LCTF_PORTAL_BRAND_LOGO_SRC =
  '/assets/logo/lctf-logo-portal-pin-transparent.png';
